// import Vue from "vue";

import {selectRollLoad} from "@/utils/directives/select";
import { permission } from '@/directive/permission/permission'
const directives = {
	selectRollLoad,
	permission
}

export default {
  install(Vue){
    Object.keys(directives).forEach((key)=>{
      Vue.directive(key,directives[key])
    })
  }
}
